import { Flex, Row } from "antd";
import { HOME_DASHBOARD_CARDS } from "../../utils/constants";
import HomeDashboardCard from "./HomeDashboardCard";
import HomeDashboardDiv from "./HomeDashboardDiv";

const formatCurrency = (value) =>
  value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

const formatNumberBr = (value) =>
  value.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const formatIntegerBr = (value) =>
  Number(value || 0).toLocaleString("pt-BR", { maximumFractionDigits: 0 });

const formatOneDecimalBr = (value) =>
  Number(value || 0).toLocaleString("pt-BR", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });

export default function HomeDashboard({
  cartoes,
  isLoadingCartoes,
  branchIds,
  periodo,
}) {
  return (
    <Flex vertical flex={1} gap={20} style={{ padding: "0 2rem" }}>
      <Row
        gutter={[
          { xs: 16, sm: 20, md: 24, lg: 32, xl: 40 },
          { xs: 16, sm: 20, md: 24, lg: 32, xl: 40 },
        ]}
        justify="start"
        align="middle">
        {HOME_DASHBOARD_CARDS.map((card, index) => (
          <HomeDashboardCard
            key={index}
            {...card}
            value={Number(cartoes?.[card.key] || 0)}
            tagValue={Number(cartoes?.[card.tagValue] || 0)}
            cardKey={card.key}
            formatter={
              card.key === "conversao"
                ? formatOneDecimalBr
                : card.formatter === "currency"
                  ? formatCurrency
                  : card.formatter === "number_br"
                    ? formatNumberBr
                    : formatIntegerBr
            }
            isLoading={isLoadingCartoes}
          />
        ))}
      </Row>

      <Row xs={24} sm={24} md={24} lg={12} xl={12} style={{ width: "100%" }}>
        <HomeDashboardDiv
          title_high="Zonas em alta"
          title_low="Zonas em baixa"
          type="zones"
          branchIds={branchIds}
          periodo={periodo}
        />

        <HomeDashboardDiv
          title_high="Categorias em alta"
          title_low="Categorias em baixa"
          type="collections"
          branchIds={branchIds}
          periodo={periodo}
        />
      </Row>
    </Flex>
  );
}
